module.exports = __webpack_public_path__ + "img/DE00363.de8bee25.png";